export var DropdownStatusType;
(function (DropdownStatusType) {
    DropdownStatusType["PENDING"] = "pending";
    DropdownStatusType["LOADING"] = "loading";
    DropdownStatusType["ERROR"] = "error";
    DropdownStatusType["FINISHED"] = "finished";
})(DropdownStatusType || (DropdownStatusType = {}));
//# sourceMappingURL=internal.js.map